<template>
  <div class="big-map-box">
    <div class="map-title">{{ title }}</div>
    <div class="map-content" id="Poimap"></div>
    <div class="map-darkcorner"></div>
    <div @click="layer.setFitView()" class="set-fitview" v-if="fitviewBtnFlag">归位</div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'Poimap',
  props: {
    title: {
      type: String,
      default: ''
    },
    poiData: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      map: null,
      layer: null,
      fitviewBtnFlag: false,
      infoWin: null,
      tableDom: null,
    }
  },
  mounted() {
    this.initChart()
  },
  methods: {
    initChart() {
      this.map = new AMap.Map('Poimap', {
        mapStyle: 'amap://styles/b5500447492ee5d38f79824b6e68aec4',
        zoom: 10
      })
      setInterval(() => {
        this.map.on('mapmove', () => {
          this.fitviewBtnFlag = true
        })
      }, 1000)
      this.initLayer()
    },
    initLayer() {
      this.layer = new Loca.IconLayer({
        eventSupport: true,
        map: this.map
      })

      this.layer.setData(this.poiData, {
        lnglat: 'location'
      })

      this.layer.setOptions({
        source: res => {
          var value = res.value
          var typecode = value.typecode
          // 这里需要写上 http 协议，不能忽略
          var src = value.icon
          return src
        },
        style: {
          size: 60
        }
      })

      this.layer.on('mousemove', ev => {
        // 事件类型
        var type = ev.type
        // 当前元素的原始数据
        var rawData = ev.rawData
        // 原始鼠标事件
        var originalEvent = ev.originalEvent
        this.openInfoWin(this.map, originalEvent, {
          名称: rawData.name,
          位置: rawData.address
        })
      })

      this.layer.on('mouseleave', ev => {
        this.closeInfoWin()
      })

      this.layer.render()
      this.layer.setFitView()
    },
    openInfoWin(map, event, content) {
      if (!this.infoWin) {
        this.infoWin = new AMap.InfoWindow({
          isCustom: true, //使用自定义窗体
          offset: new AMap.Pixel(130, 100)
        })
      }

      var x = event.offsetX
      var y = event.offsetY
      var lngLat = this.map.containerToLngLat(new AMap.Pixel(x, y))

      if (!this.tableDom) {
        let infoDom = document.createElement('div')
        infoDom.className = 'info'
        this.tableDom = document.createElement('table')
        infoDom.appendChild(this.tableDom)
        this.infoWin.setContent(infoDom)
      }

      var trStr = ''
      for (var name in content) {
        var val = content[name]
        trStr +=
          '<tr>' +
          '<td class="label">' +
          name +
          ':</td>' +
          '<td>&nbsp;</td>' +
          '<td class="content">' +
          val +
          '</td>' +
          '</tr>'
      }

      this.tableDom.innerHTML = trStr
      this.infoWin.open(this.map, lngLat)
    },
    closeInfoWin() {
      if (this.infoWin) {
        this.infoWin.close()
      }
    }
  }
}
</script>

<style scoped lang="less">
</style>
